import { clinicApi } from "@api";
import { ComponentHeader, StyledStaticPage } from "@components";
import { IProfile } from "@interfaces";
import { ProfileInfo } from "@modules";
import { setLoading, updateProgram } from "@redux";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router";
import { PATH_REDEEM_CDIC_COUPON, PATH_REDEEM_COUPON } from "src/Configs/routes";

export const PageProfile = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const history = useHistory();
  const [program, setProgram] = useState<string[]>([]);
  const [data, setData] = useState<IProfile>();

  useEffect(() => {
    fetchMyProfile();
  }, ["fetch profile"]);

  useEffect(() => {
    if(program.length > 0) {
      if (program.includes("CDIC")) {
        history.push(PATH_REDEEM_CDIC_COUPON);
      }else if (program.includes("MNCH")) {
        history.push(PATH_REDEEM_COUPON);
      }
    }
  }, [program]);

  const fetchMyProfile = async () => {
    try {
      dispatch(setLoading(true));
      const res = await clinicApi.profile();
      setData(res?.data?.data);
      dispatch(updateProgram(res?.data?.data?.joinedProgram || []));
      setProgram(res?.data?.data?.joinedProgram || []);
      dispatch(setLoading(false));
    } catch (err: any) {
      dispatch(setLoading(false));
    } finally {
      dispatch(setLoading(false));
    }
  };
  return (
    <>
      <ComponentHeader title={t("page.my_profile")} />
      <StyledStaticPage>
        <ProfileInfo data={data} />
      </StyledStaticPage>
    </>
  );
};
